import React from "react";

const Inicio = () => {
  let styleH1 = {
    fontSize:"2.5rem",
    color:"white"
};
let styleP = {
      color:"white",
    fontSize: "1.5rem",
  };
  return (
    <div
      style={{
        width: "100%",
        height: "80vh",
        fontFamily: "sans-serif",
      }}
    >
      <div
        style={{
          width: "80%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
          marginLeft: "1rem",
        }}
      >
        <h1 style={ styleH1 }>Personas más buscadas por el FBI </h1>
        <p style={ styleP }>
          En esta página encontrarás información sobre las personas más
          buscadas por el FBI. Puedes ver más información sobre la API en{" "}
          <a style={{color:"white"}}
            href="https://www.fbi.gov/wanted/api"
            target="_blank"
            rel="noreferrer"
          >
            aquí
          </a>
        </p>
      </div>
    </div>
  );
};

export default Inicio;
